<template>
  <FloatingCard class="stack" :feeling="feeling">
    <TextField
      v-model="username"
      type="text"
      :label="usernameLabel"
      :disabled="usernameDisabled"
      id="flexi-username"
    />
    <TextField
      v-model="password"
      type="password"
      :label="passwordLabel"
      :helper="passwordHelper"
      :disabled="passwordDisabled"
      :feeling="feeling"
      id="flexi-password"
    />
    <ButtonComponent
      v-show="status !== 'logged-in'"
      :label="loginLabel"
      :disabled="loginDisabled"
      @click="checkLogin"
    />
  </FloatingCard>
</template>

<script>
import TextField from '@/components/TextField';
import ButtonComponent from '@/components/ButtonComponent';
import FloatingCard from '@/components/FloatingCard';

import Flexi from '@/mixins/Flexi';

export default {
  name: 'FlexiCheckLoginCard',
  components: {
    TextField,
    ButtonComponent,
    FloatingCard,
  },
  mixins: [
    Flexi,
  ],
  props: {
    apiURL: {
      type: String,
    },
  },
  data() {
    return {
      status: null,
      username: null,
      usernameLabel: 'Uživatelské jméno do Flexi',
      password: null,
      passwordLabel: 'Heslo do Flexi',
      loginLabel: 'Přihlásit',
      logoutLabel: 'Odhlásit',
    };
  },
  computed: {
    feeling() {
      switch (this.status) {
        case 'logging-in':
          return 'pending';
        case 'logged-in':
          return 'positive';
        case 'invalid-credentials':
          return 'negative';
        case 'something-wrong':
          return 'negative';
        default:
          return null;
      }
    },
    passwordHelper() {
      switch (this.status) {
        case 'invalid-credentials':
          return 'Bylo zadáno neplatné uživatelské jméno nebo heslo';
        case 'something-wrong':
          return 'Něco se pokazilo, ozvěte se nám prosím';
        default:
          return null;
      }
    },
    usernameDisabled() {
      return this.status === 'logged-in';
    },
    passwordDisabled() {
      return this.status === 'logged-in';
    },
    loginDisabled() {
      return !(this.apiURL && this.username && this.password);
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
    },
  },
  methods: {
    async checkLogin() {
      try {
        this.status = 'logging-in';
        await this.$_Flexi_listCompanies({
          apiURL: this.apiURL,
          username: this.username,
          password: this.password,
        });
        this.status = 'logged-in';
      } catch (error) {
        if (error.response.status === 401) {
          this.status = 'invalid-credentials';
        } else {
          this.status = 'something-wrong';
          throw error;
        }
      }
    },
  },
};
</script>
